const SUBSCRIBED_KEY = "rocket_newsletter_popup_subscribed";
const SESSION_DISMISSED_KEY = "rocket_newsletter_popup_dismissed_session";

function getPopupConfig() {
  const newsletter =
    typeof window.rocketNewsletter === "object"
      ? window.rocketNewsletter
      : null;
  return newsletter?.popup && typeof newsletter.popup === "object"
    ? newsletter.popup
    : null;
}

function hasSubscribed() {
  try {
    return window.localStorage.getItem(SUBSCRIBED_KEY) === "1";
  } catch {
    return false;
  }
}

function isDismissedThisSession() {
  try {
    return window.sessionStorage.getItem(SESSION_DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

export function markNewsletterPopupSubscribed() {
  try {
    window.localStorage.setItem(SUBSCRIBED_KEY, "1");
    window.sessionStorage.setItem(SESSION_DISMISSED_KEY, "1");
  } catch {
    // Ignore storage errors.
  }
}

function markNewsletterPopupDismissedForSession() {
  try {
    window.sessionStorage.setItem(SESSION_DISMISSED_KEY, "1");
  } catch {
    // Ignore storage errors.
  }
}

function isAnotherModalOpen() {
  return Boolean(
    document.querySelector(
      ".global-modal.is-open:not([data-newsletter-popup]):not([hidden])",
    ),
  );
}

function shouldSkipPopup() {
  return hasSubscribed() || isDismissedThisSession();
}

export default function initNewsletterPopup(root = document) {
  const scope = root && root.querySelectorAll ? root : document;
  const modal = scope.querySelector("[data-newsletter-popup]");

  if (!modal || modal.__newsletterPopupBound) {
    return;
  }

  const config = getPopupConfig() || {};

  if (shouldSkipPopup()) {
    return;
  }

  modal.__newsletterPopupBound = true;

  const closeButtons = modal.querySelectorAll("[data-newsletter-popup-close]");
  let lastActiveElement = null;
  let openTimer = 0;

  const openModal = () => {
    if (
      modal.classList.contains("is-open") ||
      isAnotherModalOpen() ||
      shouldSkipPopup()
    ) {
      return;
    }

    lastActiveElement = document.activeElement;
    modal.hidden = false;
    modal.removeAttribute("hidden");
    modal.setAttribute("aria-hidden", "false");
    modal.classList.add("is-open");
    document.documentElement.classList.add("global-modal-open");

    const focusable = modal.querySelector(
      "input:not([type='hidden']), button, textarea, select, [tabindex]:not([tabindex='-1'])",
    );
    if (focusable && typeof focusable.focus === "function") {
      focusable.focus();
    }
  };

  const closeModal = () => {
    if (!modal.classList.contains("is-open")) {
      return;
    }

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    modal.hidden = true;
    modal.setAttribute("hidden", "");
    document.documentElement.classList.remove("global-modal-open");

    if (lastActiveElement && typeof lastActiveElement.focus === "function") {
      lastActiveElement.focus();
    }
  };

  const dismissPopup = () => {
    markNewsletterPopupDismissedForSession();
    closeModal();
  };

  closeButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      dismissPopup();
    });
  });

  document.addEventListener("keydown", (event) => {
    if (!modal.classList.contains("is-open")) {
      return;
    }
    if (event.key === "Escape") {
      event.preventDefault();
      dismissPopup();
    }
  });

  modal.addEventListener("newsletter:subscribed", () => {
    markNewsletterPopupSubscribed();
    window.setTimeout(() => closeModal(), 1800);
  });

  const delay = Number(config.delay_ms) || 3000;
  openTimer = window.setTimeout(() => {
    openModal();
  }, delay);

  window.addEventListener(
    "pagehide",
    () => {
      if (openTimer) {
        window.clearTimeout(openTimer);
      }
    },
    { passive: true },
  );
}
